import StyledSvgIconWrapper, { TStyledSvgIconWrapper } from "./wrappers/StyledSvgIconWrapper";

export const GSMTopUpIcon: React.FC<TStyledSvgIconWrapper> = ({ active = false, monochrome, ...props }) => {
  return (
    <StyledSvgIconWrapper {...props} active={active} width="64px" height="87px" viewBox="0 -2 64 89">
      <svg width="57" height="64" viewBox="0 0 57 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M45.78 16.43V7.61C45.78 4.51 43.11 2 39.81 2H7.97C4.67 2 2 4.51 2 7.61V56.25C2 59.35 4.67 61.86 7.97 61.86H39.81C43.11 61.86 45.78 59.35 45.78 56.25V39.14"
          stroke="#003939"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
          className={monochrome ? "stroke" : ""}
        />
        <path
          d="M23.71 29.02H54.25"
          stroke="#32B88E"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="stroke"
        />
        <path
          d="M33.94 13.84C28.98 22.36 17.98 29.02 17.98 29.02C17.98 29.02 28.65 35.53 33.71 43.83"
          stroke="#32B88E"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="stroke"
        />
      </svg>
    </StyledSvgIconWrapper>
  );
};
